
import CableReady from 'cable_ready'
import consumer from "./consumer"

if (document.querySelector("meta[name=current_user]")) {
  document.addEventListener('turbolinks:load', () => {
    consumer.subscriptions.create("CarparkChannel", {
      connected() {},
      received(data) { if (data.cableReady) CableReady.perform(data.operations) },
      disconnect() { }
    })
  })
}
